import {defineStore} from "pinia";

export const allTabs = [
    {
        name: "custom",
        title: "首页",
        activeIcon: "/mp-static/images/home-black.png",
        inactiveIcon: "/mp-static/images/home-white.png",
        key: "page_custom_index_enabled",
        titleKey: "page_custom_index_name",
    }, {
        name: "card",
        title: "名片",
        activeIcon: "/mp-static/tabbar/user-tabbar1-1.png",
        inactiveIcon: "/mp-static/tabbar/user-tabbar1.png",
        key: "page_card_enabled",
    }, {
        name: "ai",
        title: "AI检测",
        activeIcon: "/mp-static/images/ai-black.png",
        inactiveIcon: "/mp-static/images/ai-white.png",
        key: "page_ai_enabled",
        path: "/packagesF/detectIndex/detectIndex"
    }, {
        name: "detect",
        title: "诊断",
        activeIcon: "https://static.ycsd.work/collocation-helper/tabbar/zd-icon-1.png",
        inactiveIcon: "https://static.ycsd.work/collocation-helper/tabbar/zd-icon-2.png",
        key: "page_detect_enabled",
        path: "/packagesE/detectStyle/detectStyle"
    }, {
        name: "service",
        title: "服务",
        activeIcon: "/mp-static/tabbar/user-tabbar2-1.png",
        inactiveIcon: "/mp-static/tabbar/user-tabbar2.png",
        key: "page_service_enabled",
    }, {
        name: "shop",
        title: "商城",
        activeIcon: "/mp-static/tabbar/shop-active.png",
        inactiveIcon: "/mp-static/tabbar/shop.png",
        key: "page_shop_enabled",
    }, {
        name: "reservation",
        title: "预约",
        activeIcon: "https://static.ycsd.work/collocation-helper/tabbar/reservation-1.png",
        inactiveIcon: "https://static.ycsd.work/collocation-helper/tabbar/reservation-2.png",
        key: "page_appointment_enabled",
    }, {
        name: "scheme",
        title: "搭配",
        activeIcon: "/mp-static/tabbar/user-tabbar3-1.png",
        inactiveIcon: "/mp-static/tabbar/user-tabbar3.png",
        key: "page_scheme_enabled",
    }, {
        name: "cases",
        title: "案例",
        activeIcon: "/mp-static/images/case-black.png",
        inactiveIcon: "/mp-static/images/case-white.png",
        key: "page_cases_enabled",
    }, {
        name: "my",
        title: "我的",
        activeIcon: "/mp-static/tabbar/user-tabbar4-1.png",
        inactiveIcon: "/mp-static/tabbar/user-tabbar4.png",
    },
];


export const useMpStore = defineStore('mpStore', {
    state: () => {
        return {
            tabs: [],
            currentTab: null,
            config: {}
        }
    },
    actions: {
        initConfig(config = null) {
            this.config = config
            this.loadConfigTabs()
        },
        setCurrentTabName(current) {
            this.currentTab = current
        },
        setTabs(tabs) {

            // 1. 强制检查并添加 'my' (保持之前的逻辑)
            if (!tabs.find(item => item.name === 'my')) {
                let my = allTabs.find(item => item.name === 'my')
                if (my) tabs.push({...my, enabled: true})
            }

            // 2. 增删逻辑 (保持之前的逻辑，处理数量变化)
            // 2.1 删除不存在的
            for (let i = this.tabs.length - 1; i >= 0; i--) {
                const oldItem = this.tabs[i];
                const existsInNew = tabs.some(newItem => newItem.name === oldItem.name);
                if (!existsInNew) {
                    this.tabs.splice(i, 1);
                }
            }

            // 2.2 追加新出现的
            const newItems = tabs
                .filter(newItem => !this.tabs.some(oldItem => oldItem.name === newItem.name))
                .map(item => ({...item, enabled: true}));

            if (newItems.length > 0) {
                this.tabs.push(...newItems);
            }

            // ============================================
            // 3. 【新增核心逻辑】同步顺序 (Reorder)
            // ============================================
            // 此时 this.tabs 的内容集合已经和 tabs 一样了，但顺序可能不同。
            // 我们依据传入的 tabs 的顺序，对 store 里的 this.tabs 进行排序。

            // 生成一个 "name -> index" 的查找表，复杂度 O(N)
            const orderMap = new Map(tabs.map((item, index) => [item.name, index]));

            // 原地排序 this.tabs
            this.tabs.sort((a, b) => {
                const indexA = orderMap.has(a.name) ? orderMap.get(a.name) : 999;
                const indexB = orderMap.has(b.name) ? orderMap.get(b.name) : 999;
                return indexA - indexB;
            });
        },
        loadConfigTabs() {
            let appConfig = this.config

            let tabBar = appConfig['tab_bar']

            if (!tabBar) {
                this.loadOldTabs(appConfig)
                return;
            }
            // [{name,custom_title,enabled}]

            let tabs = tabBar
                .map(savedTab => {
                    // 1. 在静态常量池中找到对应的功能定义
                    const staticItem = allTabs.find(item => item.name === savedTab.name);

                    // 2. 如果功能已经不存在（比如 allTabs 里删除了该功能），则跳过
                    if (!staticItem) return null;

                    // 3. 合并数据：静态定义打底 + 配置状态覆盖
                    return {
                        ...staticItem,          // 获取 icon, path, 默认 title 等
                        enabled: savedTab.enabled,
                        custom_title: savedTab.custom_title
                    };
                })
                .filter(item => item !== null); // 过滤掉找不到对应静态定义的脏数据

            // 此时 tabs 的顺序是完全跟随 tabBar 的
            this.setTabs(tabs)
        },
        loadOldTabs(appConfig) {

            let tabs = []

            for (let idx in allTabs) {

                let tab = {...allTabs[idx]}

                if (appConfig[tab.key] === true || tab.name === 'my') {

                    if (tab.titleKey && appConfig[tab.titleKey]) {

                        tab.title = appConfig[tab.titleKey]
                    }

                    tab.enabled = true

                    tabs.push(tab)

                    if (((idx + 1) === Number(this.tab)) || (tab.name === this.tab)) {
                        this.value = tab.name
                    }
                }
            }

            this.tabs = tabs;
        }
    }
})